export default function () {
  const route = useRoute()
  const config = useRuntimeConfig()

  return {
    href: `${config.public.BASE_URL}${route.path}`
  }
}
